var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showOverlay
    ? _c(
        "div",
        { staticClass: "loading" },
        [
          _c("b-spinner", {
            staticStyle: { width: "6rem", height: "6rem" },
            attrs: { label: "Loading..." }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }